'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_book_cover_fill.svg';
import styles from './styles.module.scss';
export const BadgeCover = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><Icon width={12} height={12} color="#ffffff" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};